import * as React from 'react';
import { FC } from 'react';
import useInputErrorsDebouncer from 'app/useInputErrorsDebouncer';
import type { Locales, Errors, Values, ChangeValues } from './types';
import Spinner from './Spinner';
import { INVALID_EMAIL_FORMAT_ERROR } from './useEmailValidation';

const Email: FC<{
  values: Values;
  changeValues: ChangeValues;
  errors: Errors;
  locales: Locales;
  isValidating: boolean;
}> = ({ values, changeValues, errors, locales, isValidating }) => {
  const { email } = values;
  const [canShowErrors, delayErrors] = useInputErrorsDebouncer();
  const showErrors = email && canShowErrors;
  const emailErrors = errors.email || [];
  const notFormatErrors = emailErrors.filter((e) => e !== INVALID_EMAIL_FORMAT_ERROR).join(', ');

  return (
    <div className={`input player_email ${showErrors && emailErrors.length ? 'error' : ''}`}>
      <div className="input-with-icon">
        <input
          autoComplete="off"
          placeholder={locales.email.placeholder}
          type="email"
          name="player[email]"
          id="player_email"
          value={email}
          onChange={(e) => {
            changeValues({ email: e.target.value });
            delayErrors();
          }}
        />
        <span className="icon" />
        {isValidating && <Spinner />}
      </div>
      {showErrors && <small className="error">{notFormatErrors}</small>}
    </div>
  );
};

export default Email;
